export const GeneratorIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='currentColor'
      fillRule='evenodd'
      clipRule='evenodd'
    >
      <path d='M20.7197 5C21.3822 5.00026 21.9199 5.53762 21.9199 6.2002V16.9727C21.9199 17.6352 21.3822 18.1726 20.7197 18.1729H18.8398V19.9502H17.04V18.1729H7.04004V19.9502H5.24023V18.1729H3.2002L3.07715 18.167C2.47211 18.1055 1.99902 17.5939 1.99902 16.9727V6.2002C1.99903 5.57892 2.4721 5.06737 3.07715 5.00586L3.2002 5H20.7197ZM3.5 8.01953C3.54593 8.00735 3.59349 8.00002 3.64258 8H5.35742C5.71233 8.00018 6 8.33589 6 8.75C6 9.1641 5.71233 9.49982 5.35742 9.5H3.64258C3.59341 9.49998 3.546 9.49171 3.5 9.47949V10.5195C3.54593 10.5074 3.59349 10.5 3.64258 10.5H5.35742C5.71233 10.5002 6 10.8359 6 11.25C6 11.6641 5.71233 11.9998 5.35742 12H3.64258C3.59341 12 3.546 11.9917 3.5 11.9795V13.0195C3.54593 13.0074 3.59349 13 3.64258 13H5.35742C5.71233 13.0002 6 13.3359 6 13.75C6 14.1641 5.71233 14.4998 5.35742 14.5H3.64258C3.59341 14.5 3.546 14.4917 3.5 14.4795V16.6729H7.84082V9.30469C7.84098 8.68122 8.28914 8.16742 8.86426 8.10547L8.98145 8.09961H17.6992C18.329 8.10006 18.8407 8.63971 18.8408 9.30469V16.6729H20.4199V6.5H3.5V8.01953ZM9.2666 16.5938H17.4141V9.60645H9.2666V16.5938Z' />
    </svg>
  );
};
